import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { ContextsContextsService } from 'src/app/services/contexts-services/contexts-contexts-services/contexts-contexts.service';
import { Context } from 'src/app/models/contexts-models/context.model';

@Component({
  selector: 'app-contexts-contexts-breadcrumb-filter-card',
  templateUrl: './contexts-contexts-breadcrumb-filter-card.component.html',
  styleUrls: ['./contexts-contexts-breadcrumb-filter-card.component.scss']
})
export class ContextsContextsBreadcrumbFilterCardComponent implements OnInit {

  @Input() contexts;
  centers;
  centersForm = new FormGroup({});

  constructor(private userStorageService: UserStorageService,
    private contextsContextsService: ContextsContextsService) { }

  ngOnInit() {
    this.getCenters();
    if (this.userStorageService.getFilterContexts()) {
      this.centersForm.patchValue(this.userStorageService.getFilterContexts()['centersForm']);
    }
    this.filter();
  }

  public updateCheckbox(form, reset?) {
    this._toggleCheckboxes(form, reset);
  }

  private _toggleCheckboxes(form, reset) {
    if (reset && form.get('all').value) {
      Object.entries(form.controls).forEach(c => (c[0] !== 'all') ? (c[1] as FormControl).setValue(false) : null);
    } else if (Object.entries(form.controls).find(c => (c[0] !== 'all') && (c[1] as FormControl).value)) {
      form.get('all').setValue(false);
    } else if (!Object.entries(form.controls).find(c => (c[1] as FormControl).value)) {
      form.get('all').setValue(true);
    }
    this.userStorageService.setFilterContexts({ centersForm: this.centersForm.getRawValue() });
    if (this.userStorageService.getFilterContexts()['centersForm']['all']) {
      this.userStorageService.deleteFilterContexts();
    }
    this.filter();
  }

  private getCenters() {
    const centers = new Array<string>();
    this.centersForm.addControl('all', new FormControl(true));
    this.contexts.forEach((d: Context) => {
      if (centers.indexOf(d.CenterName) === -1) {
        centers.push(d.CenterName);
        this.centersForm.addControl(d.CenterName, new FormControl(false));
      }
    });
    this.centers = centers;
  }

  public filter() {
    const contexts = {
      centersForm:
      {
        attribute: 'CenterName',
        values: []
      }
    };
    if (this.centersForm.get('all').value) {
      contexts['centersForm'].values = Object.keys(this.centersForm.value).splice(1);
    } else {
      Object.entries(this.centersForm.value).forEach(c => { if (c[1]) { contexts['centersForm'].values.push(c[0]); }});
    }
    this.contextsContextsService.filterContexts(contexts);
  }
}
